export default __webpack_public_path__ + "static/media/settings_dropdown.75a73dfe.png";